import { MutableRefObject, useEffect, useRef } from 'react';

export const useMountedComponent = (): MutableRefObject<boolean> => {
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
};
